import { render } from "./ExpenseBotCounter.vue?vue&type=template&id=bd588d54&scoped=true"
import script from "./ExpenseBotCounter.vue?vue&type=script&lang=js"
export * from "./ExpenseBotCounter.vue?vue&type=script&lang=js"

import "./ExpenseBotCounter.vue?vue&type=style&index=0&id=bd588d54&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-bd588d54"

export default script